module.exports = __webpack_public_path__ + "img/company-consent-banner-mobile.6760cc9a.svg";